import { clientEnv } from '@/shared/config/env';
import { requestJson } from '@/shared/request/http-client';

export interface JackpotPool {
  collected: boolean[];
  maxMinor: number;
  minMinor: number;
  poolKey: string;
  title: string;
}

export interface JackpotTask {
  chances: number;
  condition: string;
  granted: boolean;
  progressMinor: number;
  taskKey: string;
  thresholdMinor: number;
}

export interface JackpotWinner {
  name: string;
  prizeMinor: number;
}

export interface JackpotState {
  chancesRemaining: number;
  claimableMinor: number;
  countdownSec: number;
  drawCostMinor: number;
  pendingMinor: number;
  pointsMinor: number;
  pools: JackpotPool[];
  tasks: JackpotTask[];
  vipLevel: number;
  winners: JackpotWinner[];
}

export interface JackpotDrawResult {
  collected: boolean[];
  completed: boolean;
  chancesAfter: number;
  duplicate: boolean;
  emptyDraw?: boolean;
  letter: string;
  letterIndex: number;
  pointsAfter: number;
  poolKey: string;
  prizeMinor: number;
}

export interface JackpotClaimResult {
  claimableAfter: number;
  duplicate: boolean;
  rewardMinor: number;
}

const siteQuery = () => `siteId=${encodeURIComponent(clientEnv.siteId)}`;

export const getJackpotState = (authToken?: string) =>
  requestJson<JackpotState>(`/v1/app/jackpot/state?${siteQuery()}`, {
    authToken: authToken || undefined,
    method: 'GET',
  });

export const drawJackpot = (authToken: string, clientRequestNo: string) =>
  requestJson<JackpotDrawResult, { clientRequestNo: string; siteId: string }>(
    '/v1/app/jackpot/draw',
    {
      authToken,
      body: { clientRequestNo, siteId: clientEnv.siteId },
      method: 'POST',
    },
  );

export const claimJackpot = (authToken: string) =>
  requestJson<JackpotClaimResult, { siteId: string }>('/v1/app/jackpot/claim', {
    authToken,
    body: { siteId: clientEnv.siteId },
    method: 'POST',
  });

export const newJackpotRequestNo = () =>
  `j${Date.now().toString(36)}${Math.random().toString(36).slice(2, 10)}`;
